import { useEffect } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import {
  Home,
  BookOpen,
  Users,
  MessageSquare,
  BarChart3,
  Settings,
  Bell,
  Search,
  User as UserIcon,
  PlusCircle,
  FileText,
  Calendar,
  FolderOpen,
  LifeBuoy,
  Globe,
} from "lucide-react";
import DashboardLayout from "../dashboard/DashboardLayout";
import NavItem, { NavSection } from "../dashboard/components/navItem";
import ScrollToTop from "../../utils/scrollToTop";
import RoleSwitcher from "../../components/layout/RoleSwitcher";

const InstructorDashboardLayout = () => {
  const location = useLocation();

  useEffect(() => {
    localStorage.setItem("from", location.pathname);
  }, [location.pathname]);

  const SidebarNav = (
    <>
      <NavItem to="/instructor/dashboard" icon={Home} label="Dashboard" end />

      <NavSection label="Teaching & Curriculum" />
      <NavItem
        to="/instructor/dashboard/my-courses"
        icon={BookOpen}
        label="My Courses"
        end
      />
      <NavItem
        to="/instructor/dashboard/students"
        icon={Users}
        label="Students"
        end
      />
      <NavItem
        to="/instructor/dashboard/assignments"
        icon={FileText}
        label="Assignments"
        end
      />
      <NavItem
        to="/instructor/dashboard/resources"
        icon={FolderOpen}
        label="Resources"
        end
      />

      <NavSection label="Community & Messaging" />
      <NavItem
        to="/instructor/dashboard/messages"
        icon={MessageSquare}
        label="Messages"
        end
      />
      <NavItem
        to="/instructor/dashboard/community"
        icon={Globe}
        label="Community"
        end
      />
      <NavItem
        to="/instructor/dashboard/event"
        icon={Calendar}
        label="Events"
        end
      />

      <NavSection label="Help & Support" />
      <NavItem
        to="/instructor/dashboard/notifications"
        icon={Bell}
        label="Notifications"
        end
      />
      <NavItem
        to="/instructor/dashboard/support"
        icon={LifeBuoy}
        label="Support"
        end
      />

      <NavSection label="Account & Preferences" />
      <NavItem
        to="/instructor/dashboard/settings"
        icon={Settings}
        label="Teaching Settings"
        end
      />
      <NavItem
        to="/instructor/dashboard/profile"
        icon={UserIcon}
        label="Profile & Settings"
        end
      />
    </>
  );

  const TopBarAddons = (
    <div className="cht-flex cht-items-center cht-gap-2">
      <RoleSwitcher />
      <div className="cht-hidden md:cht-flex cht-relative cht-mr-2 cht-group">
        <Search
          className="cht-absolute cht-left-3 cht-top-1/2 -cht-translate-y-1/2 cht-text-gray-400 group-focus-within:cht-text-[#3e57da] cht-transition-colors"
          size={16}
        />
        <input
          type="text"
          placeholder="Search courses or students..."
          className="cht-w-40 lg:cht-w-64 cht-bg-white/50 cht-border cht-border-gray-200/50 cht-rounded-xl cht-py-2 cht-pl-9 cht-pr-4 cht-text-xs cht-font-medium cht-focus:ring-2 cht-focus:ring-[#3e57da]/10 cht-focus:border-[#3e57da] cht-outline-none cht-transition-all"
        />
      </div>

      <Link
        to="/instructor/dashboard/create-course"
        className="cht-hidden sm:cht-flex cht-items-center cht-gap-2 cht-px-4 cht-py-2 cht-bg-[#3e57da] cht-text-white cht-rounded-xl cht-text-xs cht-font-bold hover:cht-bg-[#3e57da]/90 cht-transition-all active:cht-scale-95"
      >
        <PlusCircle size={14} />
        Create Course
      </Link>
    </div>
  );

  return (
    <>
      <ScrollToTop />
      <DashboardLayout
        sidebarNavContent={SidebarNav}
        topBarAddons={TopBarAddons}
      >
        <Outlet />
      </DashboardLayout>
    </>
  );
};

export default InstructorDashboardLayout;
